import React, { useState, useEffect, useCallback } from 'react'
import styled from 'styled-components'

import { colors } from 'helpers/colors'
import Flex from 'components/reusable/flex'
import Text from 'components/reusable/text'
import Indent from 'components/reusable/indent'
import Button from 'components/reusable/button'
import StripeHelpers from 'helpers/stripe_helpers'
import PaymentMethodsList from 'components/modals/v2/payment/retry_payment_modal/payment_methods_list'
import useSubmitRetryPaymentModal from 'components/modals/v2/payment/retry_payment_modal/use_submit_retry_payment_modal'
import { useRootContext } from 'hooks/use_context'
import useGetPMDisabled from 'hooks/use_get_pm_disabled'
import useGetUserPaymentCapabilities from 'hooks/api/useGetUserPaymentCapabilities'

const Wrapper = styled(Flex)`
  max-width: 440px;
  width: 100%;
  padding: 56px 56px 40px;
  position: relative;
  @media (max-width: 768px) {
    padding: 24px 16px 16px;
  }
`

const RetryPaymentModal = ({ onClose, modalProps = {} }) => {
  const { isLoading } = useRootContext()
  const { onRetryPayment, bookeeSwipecastUserId, swipecastJobId } = modalProps
  const [paymentMethods, setPaymentMethods] = useState([])
  const [selectedPM, setPM] = useState()
  const getPaymentMethodDisabled = useGetPMDisabled()
  const handleSubmit = useSubmitRetryPaymentModal(swipecastJobId, selectedPM, onRetryPayment, getPaymentMethodDisabled)
  const getUserPaymentCapabilities = useGetUserPaymentCapabilities()

  const handleInitPaymentMethods = useCallback(async () => {
    try {
      const pmList = await StripeHelpers.getStripePaymentMethods()
      setPaymentMethods(pmList)
    } catch (error) {
      if (error.status === 404) return
      console.error('Error fetching payment methods:', error)
    }
  }, [])

  useEffect(() => {
    handleInitPaymentMethods()
  }, [])

  useEffect(() => {
    if (bookeeSwipecastUserId) getUserPaymentCapabilities(bookeeSwipecastUserId)
  }, [bookeeSwipecastUserId])

  return (
    <Wrapper dir="column">
      <Text size={[{ maxWidth: 768, size: 18 }, { size: 24 }]} weight={500} textTransform="uppercase" textAlign="center">
        Select a Credit Card
      </Text>

      <PaymentMethodsList
        newCard
        onSelect={setPM}
        selectedPM={selectedPM}
        paymentMethods={paymentMethods}
        getPaymentMethodDisabled={getPaymentMethodDisabled}
      />

      <Indent bottom={40} />

      <Button
        type="primary"
        height={40}
        width="100%"
        onClick={handleSubmit}
        loading={isLoading}
        disabled={!selectedPM || (selectedPM !== 'new-card' && getPaymentMethodDisabled(selectedPM))}
      >
        Retry Payment
      </Button>
      <Indent bottom={16} />

      <Button color={colors.gray[600]} borderColor="transparent" height={40} width="100%" onClick={onClose}>
        Cancel
      </Button>
    </Wrapper>
  )
}

export default RetryPaymentModal
